// AccessControl
const OperationsModule = () => import('@pages/accessControl/Module')
const EntriesIndex = () => import('@pages/accessControl/entries/Index')
const DeparturesIndex = () => import('@pages/accessControl/departures/Index')
const MailsIndex = () => import('@pages/vigilance/mails/MailsIndex')
const MailsInternals = () => import('@pages/vigilance/mails/MailsInternals')
const MailDistribution = () => import('@pages/vigilance/mails/MailDistribution')
const ReviewIndex = () => import('@pages/accessControl/review/ReviewIndex')
const InternalReviewIndex = () => import('@pages/accessControl/internalReview/InternalReviewIndex')
// Record Book
const NotebookIndex = () => import('@pages/vigilance/notebook/NotebookIndex')
//const Faults = () => import('@pages/faults/Faults')
// const FaultForm = () => import('@pages/faults/FaultForm')
const EmergencyAlertsIndex = () => import('@pages/emergencyAlerts/Index')
const VigilancePeopleList = () => import('@pages/core/people/VigilancePeopleList')
const VigilanceAccessAuthorizationsList = () => import('@pages/internals/accessAuthorizations/VigilanceAuthorizationsList')
const VehicleNotebookIndex = () => import('@pages/vehicleNotebooks/Index.vue')
const VehicleNotebookForm = () => import('@pages/vehicleNotebooks/Form.vue')

export default {
    path: 'operations',
    component: OperationsModule,
    children: [
        {
            path: 'entries',
            component: EntriesIndex,
            name: 'entries',
        },
        {
            path: 'departures',
            component: DeparturesIndex,
            name: 'departures',
        },
        {
            path: 'mailbox',
            component: MailsIndex,
            name: 'mailbox',
        },
        {
            path: 'mail-distribution',
            component: MailDistribution,
            name: 'mail-distribution',
        },
        {
            path: 'notebook',
            component: NotebookIndex,
            name: 'vigilanceNotebook',
        },
        {
            path: 'visits',
            component: ReviewIndex,
            name: 'visits',
        },
        {
            path: 'visitas-internos',
            component: InternalReviewIndex,
            name: 'internalVisits',
        },
        {
            path: 'admin-mailbox',
            component: MailsIndex,
            name: 'adminMailBox',
        },
        {
            path: 'internal-mailbox',
            component: MailsInternals,
            name: 'internalMailbox',
        },
        // {
        //     path: 'faults',
        //     component: Faults,
        //     name: 'faults',
        // },
        // {
        //     path: ':currentFaultId/fault-edit',
        //     component: FaultForm,
        //     name: 'fault-edit',
        // },
        {
            path: 'emergency-alerts',
            component: EmergencyAlertsIndex,
            name: 'emergencyAlerts',
        },
        {
            path: 'people',
            component: VigilancePeopleList,
            name: 'vigilancePeople',
        },
        {
            path: 'access-authorizations',
            component: VigilanceAccessAuthorizationsList,
            name: 'vigilanceAccessAuthorizations',
        },
        {
            path: 'messaging-templates',
            name: 'messaging-templates',
            component: () => import('@pages/vigilance/messagingTemplates/Index'),
        },
        {
            path: 'vehicle-notebooks',
            name: 'vehicleNotebooks',
            component: VehicleNotebookIndex,
        },
        {
            path: 'new-vehicle-notebook',
            name: 'vehicleNotebookForm',
            component: VehicleNotebookForm,
        },
    ],
}
